export const pancardNumberRegex = value =>
  (value && /[A-Za-z]{5}[0-9]{4}[a-zA-Z]{1}$/.test(value)
    ? null
    : 'PAN Number is invalid');

export const bankAccountRegex = value =>
  (value && /^[A-Za-z0-9]+$/.test(value)
    ? null
    : 'Bank number should not contain special characters e.g.(.#$,)');

export const ifscCodeRegex = value =>
  (value && /^[A-Za-z0-9]{11}$/.test(value)
    ? null
    : 'IFSC code format is invalid');

export const aadharRegex = value =>
  (value && /^\d{12}$/.test(value) ? null : 'Aadhar number is invalid');

export const aadharShareCodeRegex = value =>
  (value && /^\d{4}$/.test(value) ? null : 'Share code is invalid');

export const cinRegex = value =>
  (value &&
    /^[A-Z]{3}-[0-9]{4}$|^[A-Z]{1}[0-9]{5}$|^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$|^F\w{3}-\d{4}$/.test(value)
    ? null
    : 'CIN number is invalid');

export const pincodeRegex = value =>
  (value && /^[1-9][0-9]{5}$/.test(value) ? null : 'Invalid Pincode');

export const addressRegex = value =>
  (value && /^.{3,}$/.test(value)
    ? null
    : 'Business Address should not be less than 3 characters');

export const websiteUrlRegex = value =>
  (!value ||
  /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/.test(value)
    ? null
    : 'Entered URL is invalid');

export const onlyNumber = (value) => {
  if (!value) return null;
  return (/^(\d)*$/.test(value)) ? null : 'Please enter number only';
};

export const nameAlphaNumRegex = (value) => {
  if (!value) return null;
  return (
    /^[A-Za-z0-9]+$/.test(value)
      ? null
      : 'This field should not contain special characters e.g.(.#$,)'
  );
}

export const brandNameRegex = value => {
  if (!value) return null;
  return (
    /^[a-zA-Z0-9&@#.(),:\-\s]*$/.test(value)
      ? null :
      'Name should contain only alphabets, numbers and special characters &@#.(),:-'
  )
}

export const emailRegex = value => (
  value && /^(?=.{6,254}$)[A-Za-z0-9_\-\.]{1,64}\@[A-Za-z0-9_\-\.]+\.[A-Za-z]{2,}$/.test(value)
    ? null
    : 'Invalid email'
);
